import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Cobalt — compact technical layout with a tight rhythm. Blue arrow bullets
// and rule-underlined section headings. Tuned for engineering / product roles.
export const cobaltStyles = {
  meta: { label: "Cobalt (technical)" },

  page: {
    paddingTop: 32,
    paddingBottom: 32,
    paddingLeft: 38,
    paddingRight: 38,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.35,
  },

  header: {
    marginBottom: 14,
    paddingLeft: 12,
    borderLeftWidth: 4,
    borderLeftColor: COLORS.blue,
  },
  headerName: {
    fontSize: TYPE.name,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
    letterSpacing: 0.2,
    marginBottom: 13,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: COLORS.blueSoft,
    fontFamily: FONTS.sansBold,
    marginTop: 1,
    letterSpacing: 0.2,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.slate,
    marginTop: 5,
  },
  sep: { color: COLORS.blueMuted, marginHorizontal: 3 },

  section: { marginTop: SPACING.sectionGap - 2 },
  sectionHeadingWrap: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
    paddingBottom: 2,
    borderBottomWidth: 1,
    borderBottomColor: COLORS.blue,
  },
  sectionHeading: {
    fontSize: TYPE.sectionHeading,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 1.8,
    color: COLORS.blueDeep,
    paddingRight: 6,
  },

  itemGroup: { marginBottom: SPACING.itemGap - 1 },
  itemGroupTight: { marginBottom: 3 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { color: COLORS.blueSoft, fontFamily: FONTS.sansBold },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemSubtitle: {
    fontSize: TYPE.body,
    fontFamily: FONTS.sansItalic,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: {
    fontSize: TYPE.meta,
    color: COLORS.blueDeep,
    fontFamily: FONTS.sansBold,
  },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 1 },
  chipsLine: { fontSize: TYPE.meta, marginTop: 2, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.blueDeep },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 3 },
  bulletRow: { flexDirection: "row", marginBottom: 2 },
  bulletMark: {
    width: 11,
    fontSize: TYPE.body,
    color: COLORS.blue,
    fontFamily: FONTS.sansBold,
  },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.blueSoft, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.blueSoft,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
